import React from "react";
import Modal from "../../lib/ModalWindow/Modal";
import styles from "./WishlistIsFullModal.module.scss";
import {useTranslation} from "react-i18next";
import {useWishlistContext} from "../WishlistContextProvider/WishlistContextProvider";

const WishlistIsFullModal: React.FC = () => {
  const {isWishlistFullModalShown, setIsWishlistFullModalShown} = useWishlistContext();
  const {t} = useTranslation("customerAccount");

  return (
    <Modal isVisible={isWishlistFullModalShown} closeFunction={() => setIsWishlistFullModalShown(false)}>
      <h2>{t("Ihre Wunschliste ist voll")}</h2>
      <p className={styles.subtitle}>
        {t(
          "Sie haben die maximale Anzahl von 100 Artikeln auf Ihrer Wunschliste. Um neue Artikel hinzuzufügen, entfernen Sie bitte Artikel von Ihrer Wunschliste.",
        )}
      </p>
      <a className={styles.link} href={t("/kundenkonto/wunschlisten.html")} title={t("Zur Wunschliste")}>
        {t("Zur Wunschliste")}
      </a>
    </Modal>
  );
};

export default WishlistIsFullModal;
